<template>
  <div class="ma-2">
    <v-row>
        <v-col cols="12" class="border">
            <span class="grey--text text--darken-2 body-1 font-weight-bold">Valores customizados</span>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <app-dashboard-financial-create v-on:notification="notification = $event" @getData="getList" :channel="channel"></app-dashboard-financial-create>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <app-dashboard-financial-list :loadData="loadData" @loadFalse="getListFalse" v-on:notification="notification = $event" :channel="channel"></app-dashboard-financial-list>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" class="border">
            <span class="grey--text text--darken-2 body-1 font-weight-bold">Metas</span>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <app-dashboard-financial-meta-create v-on:notification="notification = $event" @getData="getListMeta" :channel="channel"></app-dashboard-financial-meta-create>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <app-dashboard-financial-meta-list :loadData="loadMetaData" @loadFalse="getListMetaFalse" v-on:notification="notification = $event" :channel="channel"></app-dashboard-financial-meta-list>
        </v-col>
    </v-row>
    <v-snackbar
      v-model="notification.active"
      :top="true"
      :color="notification.type"
    >
      {{ notification.description }}
        <v-btn
          color="white"
          text
          @click="notification.active = false"
      >
          {{ notification.closeText }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import DashboardFinancialValuesCreate from './DashboardFinancialValuesCreate.vue'
import DashboardFinancialValuesList from './DashboardFinancialValuesList.vue'

import DashboardFinancialMetaList from './DashboardFinancialMetaList.vue'
import DashboardFinancialMetaCreate from './DashboardFinancialMetaCreate.vue'

export default {
    components: { 
        'app-dashboard-financial-create': DashboardFinancialValuesCreate,
        'app-dashboard-financial-list': DashboardFinancialValuesList,
        'app-dashboard-financial-meta-list': DashboardFinancialMetaList,
        'app-dashboard-financial-meta-create': DashboardFinancialMetaCreate,
    },
    props: {
        channel: {
            type: Number,
            required: true,
            default: null
        }
    },
    data: () => ({
        notification: {
            active: false,
            description: '',
            type: '',
            closeText: ''
        },
        loadData: false,
        loadMetaData: false
    }),
    methods: {
        getList() {
            this.loadData = true
        },
        getListFalse() {
            this.loadData = false
        },
        getListMeta() {
            this.loadMetaData = true
        },
        getListMetaFalse() {
            this.loadMetaData = false
        }
    }
}
</script>

<style>

</style>